import React, {
  Component, Fragment, useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import H3FormInput from '@Uilib/h3FormInput';
import { Select } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CMActions from '@Actions/settings/cmActions';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const FormCustomReasons = ({
  selectedCM, entity, createCMLoading, updateCMLoading, createCM, updateCM, callback,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [messageName, setMessageName] = useState('');
  const [messageType, setMessageType] = useState('');
  const [entityLevelMessageId, setentityLevelMessageId] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    if (selectedCM) {
      setMessageName(selectedCM.message);
      setMessageType(selectedCM.type);
      setentityLevelMessageId(selectedCM.entity_level_message_id);
    }
  }, [selectedCM]);

useEffect(() => {
  handleTextUpdate(entity);
}, []);

  function handleAddCM() {
    setFormSubmitted(true);
    if (entity==="STOCK ADJUSTMENT" ? !(messageName === '' || messageType === '') : !(messageName === '' )) {
      if (selectedCM) {
        const payload = {
          entity_name: entity,
          type: messageType,
          message: messageName,
          entity_level_message_id: entityLevelMessageId,
        };
        updateCM(payload, () => { callback(); });
      } else {
        const payload = {
          entity_name: entity,
          type: messageType,
          message: messageName,
        };
        createCM(payload, () => { callback(); });
      }
    }
  }

  const handleTextUpdate = (entity) => {
    if (entity === "STOCK ADJUSTMENT") {
        setText("Reason");
    } else if (entity === "BILL_OF_MATERIAL") {
        setText("Charge");
    } else {
        setText("");
    }
};
  const messageTypeoptions = [
    {
      label: 'Outwards',
      value: 'OUTWARD',
    },
    {
      label: 'Inwards',
      value: 'INWARDS',
    },
  ];
  return (
    <div>
      {' '}
      <Fragment>
        <div className="ant-row new-vendor-form__wrapper">
          <div className="ant-col-md-24">
            <H3FormInput
              name={`Custom ${text}`}
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder={`Enter ${text}`}
              onChange={(e) => setMessageName(e.target.value)}
              disabled={createCMLoading || updateCMLoading}
              value={messageName}
              label={text}
              maxlength="100"
              required
              showError={formSubmitted && !messageName}
            />
          </div>
          { (entity !== "BILL_OF_MATERIAL") && (<div className="ant-col-md-24">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Adjustment Type
                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
              </label>
              <PRZSelect
                value={messageType}
                filterOption={false}
                onChange={(value) => setMessageType(value)}
                disabled={createCMLoading || updateCMLoading}
                options={messageTypeoptions}
                showError={formSubmitted && !messageType}
                errorName="*Please select a Message Type"
                errorClassName="formError"
              />
            </div>
          </div>)
              }

          <div className="custom-drawer__footer">
            <div className="ant-col-md-6">
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text={!selectedCM ? `Add ${text}` : `Update ${text}`}
                onClick={() => handleAddCM()}
                isLoading={createCMLoading || updateCMLoading}
                disabled={createCMLoading || updateCMLoading}
                style={{
                  width: '160px',
                  borderRadius: '5px',
                  padding: '8px 10px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>

    </div>
  );
};

const mapStateToProps = ({ UserReducers, CMReducers }) => ({
  user: UserReducers.user,
  createCMLoading: CMReducers.createCMLoading,
  updateCMLoading: CMReducers.updateCMLoading,

});

const mapDispatchToProps = (dispatch) => ({
  createCM: (payload, callback) => dispatch(CMActions.createCM(payload, callback)),
  updateCM: (payload, callback) => dispatch(CMActions.updateCM(payload, callback)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormCustomReasons));
